import { DefaultStorage } from '../storage';
import { ADMIN_TOKEN_KEY } from './adminTokenKey';

export function createAdminTokenStorage(): DefaultStorage {
  return new DefaultStorage(localStorage, ADMIN_TOKEN_KEY);
}
